import { useDeepLinks } from "../hooks/deepLinking";
import { visionURL } from "../config/environment";

export async function createDeepLinkString(customerId, trainingObjectId) {
  const { createDeepLink } = useDeepLinks();
  const response = await createDeepLink(customerId, trainingObjectId);
  const deepLinkString = `${visionURL}/deep_linking/customer_deep_links?prefix=${response.deep_link_string}&training_object_id=${trainingObjectId}`;
  return deepLinkString;
}
